import React, { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type LinkProps = ComponentPropsWithoutRef<'a'>

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ children, ...props }, ref) {
  return (
    <a {...props} ref={ref}>
      {children}
    </a>
  )
})
